export default __webpack_public_path__ + "static/media/empty-hourglass.7886b5a7.svg";